import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './continuar.css';

function Continuar({ restorePrompt, discard, restore }) {

  const footerContent = (
    <div className="d-flex gap-3 justify-content-end pr-2">
      <Button 
        label="Empezar nuevo" 
        onClick={discard} 
        className="continuar-btn-secondary" 
      />

      <Button 
        label="Continuar"
        icon="pi pi-check"
        onClick={restore}
        autoFocus
        className="continuar-btn-primary"
      />
    </div>
  );

  const headerContent = (
    <div className="continuar-header-content">
      <i className="pi pi-history continuar-icon"></i>
      <div>
        <h4>¿Quieres continuar donde lo dejaste?</h4>
      </div>
    </div>
  );

  return (
    <Dialog
      header={headerContent}
      visible={restorePrompt}
      position='center'
      modal 
      blockScroll
      className="dialog-continuar"
      closable={false}
      footer={footerContent}
      draggable={false}
      resizable={false}
    >
      <p>
        Encontramos un borrador guardado en este dispositivo para este formulario. 
        Puedes retomarlo o comenzar un nuevo registro.
      </p>
    </Dialog>
  );
}

export default Continuar;